export default "__VITE_ASSET__3uEbvE9G__"